/**
 * Custom Mega Menu Connector
 * Connects menu items with custom sections based on submenu ID
 */

class CustomMegaMenuConnector {
  constructor() {
    this.customSections = new Map();
    this.observers = new Map();
    this.init();
  }

  init() {
    // Find all custom mega menu sections
    const customSectionElements = document.querySelectorAll('.mega-menu-custom-section');
    
    if (customSectionElements.length === 0) {
      console.log('No custom mega menu sections found');
      return;
    }

    console.log(`Found ${customSectionElements.length} custom mega menu section(s)`);
    
    customSectionElements.forEach(section => {
      const sectionId = section.dataset.sectionId;
      
      if (!sectionId) {
        console.warn('Custom mega menu section missing section_id', section);
        return;
      }

      // Store the custom content
      const sectionContent = section.querySelector('.mega-menu-custom-section__content');
      if (sectionContent) {
        this.customSections.set(sectionId, sectionContent.cloneNode(true));
        console.log(`Stored custom content for: ${sectionId}`);
        
        // Inject immediately
        this.injectContent(sectionId);
        
        // Setup observer to re-inject if content changes
        this.setupObserver(sectionId);
      }
    });
  }

  injectContent(sectionId) {
    const submenu = document.getElementById(sectionId);
    
    if (!submenu) {
      console.warn(`Submenu not found for ID: ${sectionId}`);
      return;
    }

    const customContent = this.customSections.get(sectionId);
    if (!customContent) {
      console.warn(`No custom content stored for: ${sectionId}`);
      return;
    }

    // Check if custom content is already injected
    if (submenu.querySelector('.mega-menu-custom-injected')) {
      console.log(`Custom content already injected in: ${sectionId}`);
      return;
    }

    console.log(`Injecting custom content into: ${sectionId}`);

    // Clone fresh content
    const clonedContent = customContent.cloneNode(true);
    clonedContent.classList.add('mega-menu-custom-injected');
    
    // Clear existing content
    submenu.innerHTML = '';
    
    // Create wrapper
    const wrapper = document.createElement('div');
    wrapper.className = 'mega-menu section section--full-width-margin section--full-width';
    wrapper.appendChild(clonedContent);
    
    // Inject
    submenu.appendChild(wrapper);
    
    console.log(`✅ Injected custom content into: ${sectionId}`);
  }

  setupObserver(sectionId) {
    const submenu = document.getElementById(sectionId);
    if (!submenu) return;

    // Create observer to watch for content changes
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        // Check if our custom content was removed
        if (!submenu.querySelector('.mega-menu-custom-injected')) {
          console.log(`Custom content was removed from ${sectionId}, re-injecting...`);
          this.injectContent(sectionId);
          break;
        }
      }
    });

    observer.observe(submenu, {
      childList: true,
      subtree: true
    });

    this.observers.set(sectionId, observer);
    console.log(`Setup observer for: ${sectionId}`);
  }

  destroy() {
    this.observers.forEach(observer => observer.disconnect());
    this.observers.clear();
    this.customSections.clear();
  }
}

// Create global instance
let connectorInstance = null;

function initConnector() {
  if (connectorInstance) {
    connectorInstance.destroy();
  }
  connectorInstance = new CustomMegaMenuConnector();
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initConnector);
} else {
  initConnector();
}

// Re-initialize after Shopify section updates (Theme Editor)
document.addEventListener('shopify:section:load', initConnector);
